import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Datasource',
    entityNamePlural: 'Datasources',
    entityNameModule: 'settings',
    filters: { active: true },
  }), [])
}
